<!--
  This example requires some changes to your config:

  ```
  // tailwind.config.js
  module.exports = {
    // ...
    plugins: [
      // ...
      require('@tailwindcss/forms'),
    ],
  }
  ```
-->
<script setup lang="ts">
  import {
    Dialog,
    DialogPanel,
    TransitionChild,
    TransitionRoot
  } from '@headlessui/vue'
  import SearchProvider from '../search-provider.vue'
  import GlobalSearchDialogContentV2 from './global-search-dialog-content-v2.vue'
  import { useTemplateRef } from 'vue'
  import { useGlobalSearchDialog } from './global-search-provider.vue'
  const searchProviderRef = useTemplateRef('searchProviderRef')

  const { closeSearchCommand, isSearchCommandOpen: isOpen } =
    useGlobalSearchDialog()
</script>
<template>
  <TransitionRoot
    :show="isOpen"
    as="template"
    appear
    @after-leave="searchProviderRef?.clearSearch()"
  >
    <Dialog class="relative z-50" @close="[closeSearchCommand()]">
      <TransitionChild
        as="template"
        enter="ease-out duration-300"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="ease-in duration-200"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <div
          class="backdrop fixed inset-0 backdrop-blur-sm transition-opacity"
        />
      </TransitionChild>

      <div
        class="fixed inset-0 z-10 w-screen overflow-y-auto p-4 sm:p-6 md:p-20"
      >
        <TransitionChild
          as="template"
          enter="ease-out duration-300"
          enter-from="opacity-0 scale-95"
          enter-to="opacity-100 scale-100"
          leave="ease-in duration-200"
          leave-from="opacity-100 scale-100"
          leave-to="opacity-0 scale-95"
        >
          <DialogPanel
            class="bg-background mx-auto max-w-xl transform overflow-hidden rounded border shadow-md transition-all"
          >
            <search-provider
              ref="searchProviderRef"
              :defaultSearchContext="'global'"
            >
              <global-search-dialog-content-v2 />
            </search-provider>
          </DialogPanel>
        </TransitionChild>
      </div>
    </Dialog>
  </TransitionRoot>
</template>
